import { ManyKeys } from './ManyKeys'
import { createFeature } from '../core'

export default createFeature({
  name: 'manykeys',
  category: 'instruments',
  description:
    'manykeys',
  instruments: [
    {
      id: 'manykeys',
      sortKey: 'manykeys',
      name: 'manykeys',
      description:
        'manykeys',
      component: ManyKeys,
    },
  ],
})
